export class loaformObj{

    // User Details
    name:string="";
    company:string="";
    emailId:string="";
    countryCode:string="+";
    phoneNo:string="";

    // LOA ID 

    loaId:string="";
    loaHolderName:string="";

    //Reason for validating
    reasonForValidating:string="";

    //Captcha
    enterCaptcha:string="";
    // enterCaptchaImage:string="";

    remarks:string="";

}